import React from 'react';
import { Container, Typography, Tabs, Tab, Box } from '@mui/material';
import { Outlet, Link, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function Publications() {
    const location = useLocation();

    return (
        <Container>

            {/* Tabs セクション */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2 }}>
                <Tabs
                    value={location.pathname}
                    textColor="inherit"
                    indicatorColor="primary"
                    sx={{
                        '.MuiTab-root': {
                            color: 'gray', // 非選択状態のタブの色
                        },
                        '.Mui-selected': {
                            color: '#1976d2', // 選択状態のタブの色
                        },
                    }}
                >
                    <Tab label="Journal" value="/publications/journal" component={Link} to="/publications/journal" />
                    <Tab label="Conference" value="/publications/conference" component={Link} to="conference" />
                    <Tab label="Books" value="/publications/book" component={Link} to="book" />
                    <Tab label="Others" value="/publications/other" component={Link} to="other" />
                    <Tab label="Awards" value="/publications/award" component={Link} to="award" />
                </Tabs>
            </Box>

            {/* デフォルトでJournalにリダイレクト */}
            {location.pathname === '/publications' && <Navigate to="/publications/journal" replace />}

            {/* サブコンポーネントの表示 */}
            <Outlet />
        </Container>
    );
}

export default Publications;
